import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee4e2ec2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "home",
  class: "flex"
}
const _hoisted_2 = {
  key: 0,
  class: "flex"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Please wait...", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  id: "github-username",
  class: "flex"
}
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Enter the "),
  /*#__PURE__*/_createElementVNode("span", null, "Github"),
  /*#__PURE__*/_createTextVNode(" username of the account you'd like to grant access (case-sensitive)")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Set Github username", -1))

import { onMounted, ref, inject } from "vue";
import { httpsCallable } from "firebase/functions";
import { functions, auth } from "@/assets/ts/firebase";
import { SHOW_TOAST } from "@/assets/ts/Constants";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

var router = useRouter();
var mitt = inject("emitter") as any;
var user = ref({} as User);
var loading = ref(true);

onMounted(async () => {
  try {
    user.value = await getUsername();
  } catch (error) {
    console.log("no data found");
  } finally {
    loading.value = false;
  }
});

const getUsername = async () => {
  return await callFunction<null, User>("getGithubUsername", null);
};

const setUsername = async () => {
  try {
    loading.value = true;
    await callFunction<User, functionCallback<null>>("setGithubUsername", user.value);
    mitt.emit(SHOW_TOAST, { title: "Great!", msg: "You should get an invite within 5 minutes.", type: "success" } as toastConfig);
    router.push("/thanks");
  } catch (error) {
    mitt.emit(SHOW_TOAST, { title: "Woops", msg: error, type: "error" } as toastConfig);
  } finally {
    loading.value = false;
  }
};

const callFunction = async <Request, functionCallbackData>(name: string, data: Request) => {
  var fun = httpsCallable<Request, functionCallback<functionCallbackData>>(functions, name);
  var result = await fun(data);
  console.log(result);
  if (result.data.success) return result.data.data;
  else {
    throw new Error(result.data.error);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(setUsername, ["prevent"]),
            class: "flex"
          }, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Github username",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(user).githubUsername) = $event))
            }, null, 512), [
              [_vModelText, _unref(user).githubUsername]
            ]),
            _hoisted_8
          ], 40, _hoisted_6)
        ]))
  ]))
}
}

})